import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { AAConstant, AppError } from 'src/app/core/models/constants';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { EventsService } from 'src/app/core/services/events.service';
import { RouteValidationMessage } from 'src/app/core/events/events';
import { RouteDataStoreService } from '../data-store/data-store.service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private currentLocation: AALocationModel;

  constructor(private appService: AppService,
              private _eventService: EventsService,
              private dataStore: RouteDataStoreService,
              private appUtilityService: AppUtilityService) {
    this.currentLocation = this.dataStore.currentLocation;
  }

  public currentLocationLoaded(): boolean {
    return this.currentLocation.valid();
  }

  public markAsCurrentLocation(locationModel: AALocationModel) {
    if (locationModel.isCurrentLocation()) {
      locationModel.apply(this.currentLocation);
    }
  }

  public loadCurrentLocation(locationModel: AALocationModel): Observable<AALocationModel> {

    return Observable.create((observer: Observer<any>) => {
      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition( (location: any) => {
          locationModel.isLoading = false;
          locationModel.Latitude = location.coords.latitude;
          locationModel.Longitude = location.coords.longitude;

          this.currentLocation.Latitude = location.coords.latitude;
          this.currentLocation.Longitude = location.coords.longitude;

          this.appService.getGeoLocationByLatLng( this.currentLocation.latLng).subscribe( address => {
            locationModel.Name = address.locationName;
            this.currentLocation.Name = address.locationName;
            console.log('***** CURRENT LOCATION IS LOADED ******', locationModel);
            observer.next(locationModel);
            observer.complete();
          });
        }, (error) => {
            console.error(AppError.LOCATION_ACCESS_DENIED_ERR);
            locationModel.clear();
            locationModel.Name = '';
            locationModel.hasError = true;
            locationModel.isLoading = false;
            let errorMsg = '';
            if (this.appUtilityService.isDesktop) {
              errorMsg = AppError.LOCATION_ACCESS_DENIED;
            } else {
              errorMsg = AppError.LOCATION_ACCESS_FEATURE_TURNON;
            }
            locationModel.errorMessage = errorMsg;
            this._eventService.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, errorMsg );
            observer.error(errorMsg);
          }
        );
      }

    });
  }

}

